<template>
  <div>
    <div v-if="loading || visible" class="loader">
      <bb-spinner/>
    </div>
    <credit-card-action-done v-else />
    <credit-card-secrets-modal
        v-if="visible"
        :type="type"
        :card-id="Number(cardId)"
        :contract-id="Number(contractId)"
        :card-type="cardType"
        :visible="visible"
        :signing-way="signingWay"
        is-mobile-app
        @onModalClosed="onModalClosed"
    />
  </div>
</template>

<script>
import CreditCardActionDone from '@credit-card/views/mobile-standalone/CreditCardActionDone.vue'
import CreditCardSecretsModal from '@credit-card/components/modals/CreditCardSecretsModal.vue'
import { CREDIT_CARD } from '@/const'
import { CardType } from '@bigbank/dc-common/clients/http/credit-card/credit-card.enums'

const actionInUrl = {
  ShowPanCvv: 'pan-cvv',
  ShowPinCode: 'pin'
}

export default {
  name: 'credit-card-secrets-page',
  components: { CreditCardSecretsModal, CreditCardActionDone },
  props: {
    cardId: {
      type: String,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    cardType: {
      type: String,
      required: true,
      validator: function (value) {
        return [CardType.PHYSICAL_AND_VIRTUAL, CardType.VIRTUAL].includes(value)
      }
    },
    contractId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      visible: false,
      loading: false,
      signingWay: CREDIT_CARD.SECRETS_MODAL_SIGNING_WAY.DEFAULT,
      type: null
    }
  },
  async created () {
    switch (this.action) {
      case actionInUrl.ShowPanCvv:
        this.type = CREDIT_CARD.SECRETS_MODAL_STEP.SHOWING_PAN_AND_CVV
        break
      case actionInUrl.ShowPinCode:
        this.type = CREDIT_CARD.SECRETS_MODAL_STEP.SHOWING_PIN
        break
      default:
        throw new Error(`Unhandled action ${this.action}`)
    }

    this.visible = true
  },
  methods: {
    onModalClosed () {
      this.visible = false
    }
  }
}
</script>
